var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm.loading && _vm.query ? [_c('Loader', {
    attrs: {
      "content-id": _vm.query,
      "message": 'Searching'
    }
  })] : _vm._e(), _c('div', [_vm.loading && _vm.query ? _c('p', [_vm._v("Searching for " + _vm._s(_vm.query))]) : _vm._e()]), !_vm.loading ? _c('p', [_vm._v(" Showing results for "), _c('span', [_vm._v(_vm._s(_vm.query))])]) : _vm._e(), !_vm.loading && _vm.results.length > 0 ? _c('div', {
    staticClass: "results"
  }, _vm._l(_vm.results, function (res, i) {
    return _c('ResultRow', {
      key: i,
      staticClass: "result_row",
      attrs: {
        "result": res
      }
    });
  }), 1) : _vm._e(), !_vm.loading && _vm.results.length === 0 ? _c('div', {
    staticClass: "not_found card"
  }, [_c('h2', [_vm._v("Not Found")]), _c('p', [_vm._v(" Couldn't find any transaction, address or asset with that query. ")])]) : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }